export default __webpack_public_path__ + "e5a6a754d8e9ec4ef0d9c66b4d72b268.svg";